import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_FULFILLMENT_COUNT, SUPERSET_FULFILLMENT_COUNT_ERROR, SUPERSET_FULFILLMENT_COUNT_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetFulfillment({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_FULFILLMENT_COUNT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_FULFILLMENT_COUNT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_FULFILLMENT_COUNT_ERROR, payload: error });
  }
}

export function* watchSupersetFulfillmentCount() {
  yield takeEvery(SUPERSET_FULFILLMENT_COUNT, supersetFulfillment);
}

function* supersetFulfillmentCountSaga() {
  yield all([fork(watchSupersetFulfillmentCount)]);
}

export default supersetFulfillmentCountSaga;
